import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { sessionQueryOptions } from '@/features/auth/api';

/** Layout pathless: exige sessão válida (com tentativa de refresh embutida no http client). */
export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData(sessionQueryOptions()).catch(() => null);
    if (!user) throw redirect({ to: '/entrar' });
  },
  component: () => <Outlet />,
});
